import types from './actionTypes';

const initialState = { fetching: false };

export default (state = initialState, action) => {
    switch (action.type) {
        case types.PARTNERS_REQUEST: {
            return {
                ...state,
                fetching: true,
            };
        }
        case types.PARTNERS_REQUEST_COMPLETED: {
            return {
                ...state,
                fetching: false,
            };
        }
        default:
            return state;
    }
};
